import React from 'react';

const BlockRenderer = ({ blocks }) => {
    if (!blocks || !Array.isArray(blocks) || blocks.length === 0) {
        return <div className="block-renderer-empty">No content blocks</div>;
    }

    const renderBlock = (block, index) => {
        const { type, data } = block;

        switch (type) {
            case 'text':
                return (
                    <div key={block.id || index} className="block text-block">
                        {data.format === 'heading1' && <h1>{data.text}</h1>}
                        {data.format === 'heading2' && <h2>{data.text}</h2>}
                        {data.format === 'heading3' && <h3>{data.text}</h3>}
                        {data.format === 'paragraph' && <p>{data.text}</p>}
                    </div>
                );

            case 'heading':
                const HeadingTag = `h${data.level || 2}`;
                return (
                    <div key={block.id || index} className="block heading-block">
                        <HeadingTag>{data.text}</HeadingTag>
                    </div>
                );

            case 'image':
                return (
                    <div key={block.id || index} className="block image-block">
                        {data.url && (
                            <img
                                src={data.url}
                                alt={data.alt || ''}
                                className="block-image"
                            />
                        )}
                        {data.caption && (
                            <p className="image-caption">{data.caption}</p>
                        )}
                    </div>
                );

            case 'list':
                const ListTag = data.ordered ? 'ol' : 'ul';
                return (
                    <div key={block.id || index} className="block list-block">
                        <ListTag className={data.ordered ? 'ordered-list' : 'bullet-list'}>
                            {(data.items || []).map((item, itemIndex) => (
                                <li key={itemIndex}>{item}</li>
                            ))}
                        </ListTag>
                    </div>
                );

            case 'quote':
                return (
                    <div key={block.id || index} className="block quote-block">
                        <blockquote className="quote-text">
                            "{data.text}"
                        </blockquote>
                        {data.author && (
                            <cite className="quote-author">— {data.author}</cite>
                        )}
                    </div>
                );

            default:
                return (
                    <div key={block.id || index} className="block unknown-block">
                        <p className="text-muted">Unknown block type: {type}</p>
                    </div>
                );
        }
    };

    return (
        <div className="block-renderer">
            {blocks.map((block, index) => renderBlock(block, index))}
        </div>
    );
};

export default BlockRenderer;
